import classNames from 'classnames';
import React, { useEffect, useRef } from 'react';
import IconClose from './IconClose';
import './index.scss';

interface EfModalProps {
    /**
     * 标题
     */
    title?: React.ReactNode;
    /**
     * 主题色
     */
    theme?: 'white' | 'black';
    /**
     * 是否打开弹窗
     */
    open: boolean;
    /**
     * 弹窗最大宽度
     */
    width?: string;
    /**
     * 窗弹展示位置
     */
    position?: 'top' | 'center';
    /**
     * 样式名
     */
    className?: string;
    /**
     * 子内容
     */
    children?: React.ReactNode;
    /**
     * 关闭回调
     */
    callback?: () => void;
    /**
     * 样式名
     */
    className?: string;
}

/**
 * 维护:谢保林
 *
 * 弹窗
 */
const EfModal: React.FC<EfModalProps> = ({ title, theme, open = true, width, position, callback, children, className }) => {
    const prefixCls = `ef-modal`;
    const refDialog = useRef(null);
    const classes = classNames(prefixCls, {
        [`${className}`]: className,
        [`${prefixCls}-${theme}`]: theme,
        [`${prefixCls}-${position}`]: position,
    });

    useEffect(() => {
        if (open) {
            (refDialog.current as any).showModal();
        }
    }, [open]);
    // 关闭
    const closeHandle = () => {
        (refDialog.current as any).close();
        callback && callback();
    };
    return (
        <dialog className={classes} ref={refDialog}>
            <div className={`${prefixCls}-wrap`}>
                <div
                    className={`${prefixCls}-content`}
                    style={{
                        maxWidth: width,
                    }}
                >
                    <div className={`${prefixCls}-title`}>{title}</div>
                    <span className={`${prefixCls}-close`} onClick={closeHandle}>
                        <IconClose />
                    </span>
                    <div className={`${prefixCls}-body`}>{children}</div>
                </div>
            </div>
        </dialog>
    );
};

export default EfModal;
